(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('LugarController', LugarController);

    /* @ngInject */
    function LugarController($translate, Edicion, Lugar, NG_LIST_DEFAULT_PARAMS_PUBLIC_MAP) {
        var vm = this;
        var page = 0;
        var filtros;
        vm.lugares = [];
        vm.entidades = [];
        vm.tipoBD = []; // Por ahora no se utiliza. Pero esto ayuda a preparar la generalización para múltiples BD
        vm.tiposEntidad = [];
        vm.tipoEntidad = "CBDRS_EDICION";
        vm.tipoEntidadFecha = "CBDRS_EDICION";
        vm.loadingEntidades = false;

        // *** Mapa

        var map = L.map('mymap', {
            center: [10.0, 5.0],
            minZoom: 2,
            zoom: 2
        });

        L.Icon.Default.imagePath = 'assets/images/static/leaflet';

        L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }
        ).addTo(map);

        var markerClusters = L.markerClusterGroup({zoomToBoundsOnClick: false, spiderfyOnMaxZoom: false});
        map.addLayer(markerClusters);

        markerClusters.on('clusterclick', function (a) {
            showEntidades(a.layer.getAllChildMarkers());
        });

        markerClusters.on('click', function (a) {
            showEntidades([a.layer]);
        });

        function populateMap() {
            markerClusters.clearLayers();
            var markersTemp = [];
            var greenIcon = L.icon({
                iconSize: [40, 40], // size of the icon
                iconUrl: L.Icon.Default.imagePath + '/marker-icon.png'
            });
            vm.lugares.forEach(function (item) {
                var lugar = item;
                if (item.lugarcanonico) {
                    lugar = item.lugarcanonico;
                }

                if (lugar && lugar.lat && lugar.lng) {
                    var marker = {
                        lat: lugar.lat,
                        lng: lugar.lng,
                        focus: true
                    };
                    // A mayores almacenamos el ID del objeto EntidadToponimo para luego recuperarlo
                    markersTemp.push(L.marker(marker, {id: item.id, title: item.nombre, icon: greenIcon}));
                }
            });
            markerClusters.addLayers(markersTemp);
            console.log("Número de markers:" + vm.lugares.length);
        }

        var activeClass = 'btn-primary-public';

        // Añadir un control (botón) para filtrar por tipo de entidad en el mapa
        function crearFiltroMapa(tipo) {
            var MapControl = L.Control.extend({
                options: {
                    position: 'topright'
                },
                onAdd: function (map) {
                    var container = L.DomUtil.create('div', 'ctrl-tipo btn btn-xs btn-default');
                    if (tipo == vm.tipoEntidad) {
                        container.classList.add(activeClass);
                    }

                    container.textContent = $translate.instant('tipos.tiposentidad.select.lugar.' + tipo);

                    L.DomEvent.addListener(container, 'click', function () {
                        angular.forEach(document.getElementsByClassName("ctrl-tipo"), function (element) {
                            element.classList.remove(activeClass);
                        });

                        container.classList.add(activeClass);
                        changeTipoEntidad(tipo);
                    });
                    return container;
                }
            });
            return new MapControl();
        }

        function addFiltroPorTipoToMap() {
            vm.tiposEntidad.forEach(function (tipo) {
                map.addControl(crearFiltroMapa(tipo));
            });
        }

        // Fin mapa ***

        // Obtener entidades por topónimo (cluster seleccionado)
        vm.showEntidades = function (markers) {
        };

        function showEntidades(markers) {
            clearEntidades();

            vm.loadingEntidades = true;
            vm.tipoEntidadActiva = vm.tipoEntidad;

            var markerIds = [];
            markers.forEach(function (marker) {
                markerIds.push(marker.options.id);
            });

            filtros = getFiltros();
            filtros.toponimoIds = markerIds;
            $("html, body").animate({scrollTop: $('#listado').offset().top - 50}, 1000);

            Edicion.filterGis(filtros).$promise.then(function (data) {
                vm.entidades = data.content;
                vm.loadingEntidades = false;
                filtros.totalElements = data.totalElements;
            });
        }

        // Filtro por años

        vm.filtro = {
            anoInicioEdicion: null,
            anoFinEdicion: null
        };

        vm.filtrar = function () {
            console.log("Filtrando");
            clearEntidades();

            Lugar.filterGis(getFiltros()).$promise.then(function (result) {
                vm.lugares = result;
                populateMap();

            });
        };

        vm.filtrar();

        function changeTipoEntidad(tipo) {
            vm.tipoEntidad = tipo;
            vm.filtrar();
        }

        // Filtros de búsqueda
        function getFiltros() {
            return {
                tipoEntidad: vm.tipoEntidad,
                tipoEntidadFecha: vm.tipoEntidadFecha,
                inicio: vm.filtro.anoInicioEdicion,
                fin: vm.filtro.anoFinEdicion,
                nombreLugar: vm.filtro.nombreLugar,
                revisado: true,
                size: NG_LIST_DEFAULT_PARAMS_PUBLIC_MAP.size,
                page: page,
                totalElements: 0
            }
        }

        vm.tiposEntidad = ["CBDRS_EDICION", "CBDRS_RELACION"];
        addFiltroPorTipoToMap();

        // Infinite Scroll. Obtenemos todas las entidades pero las vamos mostrando poco a poco
        function clearEntidades() {
            vm.entidades = [];
            vm.items = [];
            //se inicializa así porque solo se usa en loadMoore y cuando entra ahí es para obtener la segunda pagina
            vm.begin = NG_LIST_DEFAULT_PARAMS_PUBLIC_MAP.size;
        }

        clearEntidades();

        //cada vez que llega abajo de la lista, se lanza una peticion al servidor y trae los siguientes 50 elementos
        vm.loadMore = function () {
            if (vm.entidades && vm.entidades.length && (vm.begin < filtros.totalElements)) {
                vm.loadingEntidades = true;
                var max = NG_LIST_DEFAULT_PARAMS_PUBLIC_MAP.size;
                filtros.page += 1;
                Edicion.filterGis(filtros).$promise.then(function (data) {
                    vm.items = data.content;
                    vm.loadingEntidades = false;
                    for (var i = 0; i < (vm.items.length); i++) {
                        vm.entidades.push(vm.items[i]);
                    }
                    vm.begin += max;
                });
            }
        };

        vm.lugarService = Lugar;
        vm.edicionService = Edicion;

    }
})
(angular);
